import accordbank from './assets/accordbank.webp';
import bankcreditdnipro from './assets/bankcreditdnipro.webp';
import creditagricole from './assets/creditagricole.webp';
import globus from './assets/globusplus.webp';
import izibank from './assets/izibank.webp';
import kredobank from './assets/kredobank.webp';
import monobank from './assets/monobank.webp';
import mtbbank from './assets/mtbbank.webp';
import obank from './assets/obank.webp';
import otpbank from './assets/otpbank.webp';
import privat24 from './assets/privat24.webp';
import pumb from './assets/pumb.png';
import raiffiesenbak from './assets/raiffiesenbank.webp';
import sensebank from './assets/sensebank.webp';
import ugb from './assets/ugb.webp';
import ukrsibbank from './assets/ukrsibbank.webp';
import unexbank from './assets/unexbank.webp';
import vstbank from './assets/vstbank.webp';
import abank from './assets/abank.webp';

export default [
  {
    logo: monobank,
    label: 'Monobank',
    code: 'monobank',
    deeplink: {
      android: 'com.ftband.mono',
      ios: 'mono',
    },
  },
  {
    logo: privat24,
    label: 'Приват24',
    code: 'privat24',
    deeplink: {
      android: 'ua.privatbank.ap24',
      ios: 'privat24',
    },
  },
  {
    logo: abank,
    label: 'А-Банк',
    code: 'abank',
    deeplink: {
      android: 'ua.com.abank',
      ios: 'abank24',
    },
  },
  {
    logo: pumb,
    label: 'ПУМБ',
    code: 'pumb',
    deeplink: {
      android: 'com.fuib.android.spot.online',
      ios: '',
    },
  },
  {
    logo: sensebank,
    label: 'Sense Bank',
    code: 'sensebank',
    deeplink: {
      android: 'ua.alfabank.mobile.android',
      ios: qr => qr.replace('https://bank.gov.ua/qr/', 'https://superapp.sensebank.com.ua/mob/qr/'),
    },
  },
  {
    logo: ukrsibbank,
    label: 'Укрсіббанк',
    code: 'ukrsibbank',
    deeplink: {
      android: 'com.ukrsibbank.uso.android',
      ios: '',
    },
  },
  {
    logo: raiffiesenbak,
    label: 'Райффайзен Банк',
    code: 'raiffiesenbank',
    deeplink: {
      android: 'ua.raiffeisen.myraif',
      ios: '',
    },
  },
  {
    logo: ugb,
    label: 'Ukrgasbank',
    code: 'ukrgasbank',
    deeplink: {
      android: 'com.ugb.app',
      ios: '',
    },
  },
  {
    logo: izibank,
    label: 'izibank',
    code: 'izibank',
    deeplink: {
      android: 'ua.izibank.app',
      ios: '',
    },
  },
  {
    logo: mtbbank,
    label: 'МТБ Банк',
    code: 'mtbbank',
    deeplink: {
      android: 'com.ua.mtb.bank',
      ios: '',
    },
  },
  {
    logo: kredobank,
    label: 'KredoBank',
    code: 'kredobank',
    deeplink: {
      android: 'ua.android.kredobank.prod',
      ios: '',
    },
  },
  {
    logo: creditagricole,
    label: 'Креді Агріколь Банк',
    code: 'creditagricole',
    deeplink: {
      android: 'ua.creditagricole.mobile.app',
      ios: '',
    },
  },
  {
    logo: otpbank,
    label: 'ОТП БАНК',
    code: 'otpbank',
    deeplink: {
      android: 'ua.otpbank.android',
      ios: '',
    },
  },
  {
    logo: accordbank,
    label: 'Аккордбанк',
    code: 'accordbank',
    deeplink: {
      android: 'online.kapowai.accordbank',
      ios: '',
    },
  },
  {
    logo: bankcreditdnipro,
    label: 'Банк Кредит Дніпро',
    code: 'bankcreditdnipro',
    deeplink: {
      android: 'com.creditdnepr.mb',
      ios: '',
    },
  },
  {
    logo: globus,
    label: 'Глобус Банк',
    code: 'globus',
    deeplink: {
      android: 'com.t18.bone.personal.globus',
      ios: '',
    },
  },
  {
    logo: obank,
    label: 'Ідея Банк',
    code: 'ideabank',
    deeplink: {
      android: 'ua.ideabank.obank',
      ios: '',
    },
  },
  {
    logo: unexbank,
    label: 'Unex Bank',
    code: 'unexbank',
    deeplink: {
      android: 'online.kapowai.unexbank',
      ios: '',
    },
  },
  {
    logo: vstbank,
    label: 'VST bank',
    code: 'vstbank',
    deeplink: {
      android: 'com.vostok.bv',
      ios: '',
    },
  },
];
